if (!customElements.get('leelo-marquee')) {
  customElements.define('leelo-marquee', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const button = this.querySelector('button');
      button.hidden = false;
      this.setAttribute('data-ready', '');
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Resume scrolling announcements' : 'Pause scrolling announcements');
      }, options);
      this.visible = true;
      const update = () => this.toggleAttribute('data-offscreen', !this.visible || document.hidden);
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; update(); });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', update, options);
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
